import type { BusinessDetails } from '../slices/businessDetails';
import { Decline } from '../slices/decline';
import { SoftError } from '../types/error';
import { Industry } from '../types/refData';
import { isDefined } from '../utils/isDefined';
import { annnualTurnoverRule } from './annnualTurnoverRule';
import { employeeCountRule } from './employeeCountRule';
import { propertyValueRule } from './propertyValueRule';
import type { Rule } from './types';

const rules: Rule[] = [annnualTurnoverRule, employeeCountRule, propertyValueRule];
export const applyDeclineRules = (state: {
  businessDetails: Partial<BusinessDetails> | null;
  decline: Decline;
  isPropertyOwner: boolean;
  industries?: Industry[];
}) =>
  rules
    .map((rule) => rule(state))
    .filter(isDefined)
    .flat()
    .reduce(
      (acc, result) => ({
        ...acc,
        ...(result.declineType === 'soft'
          ? { softErrors: [...(acc.softErrors ?? []), result as SoftError] }
          : undefined),
        ...(result.declineType === 'hard' || result.declineType === undefined
          ? { hardErrors: [...(acc.hardErrors ?? []), result] }
          : undefined),
        ...(result.declineType === 'system'
          ? { errors: [...(acc.errors ?? []), result] }
          : undefined),
      }),
      state.decline
    );
